import { Panel } from 'ui/components'
import { useTemplateManageContext } from '~bank-document-templates/manage/context'

import { Contact, General, License, Relationship } from './components'

export const Form = () => {
  const { formApi } = useTemplateManageContext()

  return (
    <Panel rounded shadowed collapsible={false} title="Template Details" anchor="details">
      <div style={{ padding: '30px 35px' }}>
        <General />
        <formApi.Subscribe
          children={({ values: { level } }) => <>{(level === 'company' || level === 'license') && <Relationship />}</>}
        />
        <formApi.Subscribe children={({ values: { level } }) => <>{level === 'license' && <License />}</>} />
        <formApi.Subscribe children={({ values: { level } }) => <>{level === 'contact' && <Contact />}</>} />
      </div>
    </Panel>
  )
}
